import { ImageWithMetadata } from '@features/powerpoint';
import {
  SlideMasterProps,
  buildSlideMasterFooter,
  buildSlideMasterHeader,
  slideBackground,
} from '@features/powerpoint';

export const DEFAULT_SLIDE_MASTER = 'MASTER_SLIDE';
export const FOOTER_TEXT = `COPYRIGHT © INMARKET MEDIA LLC ${new Date().getFullYear()}. ALL RIGHTS RESERVED.`;

export const slideMaster = (options?: {
  masterName?: string;
  backgroundPath?: string;
  showHeader?: boolean;
  brandLogoWithMetadata?: ImageWithMetadata | null;
}): SlideMasterProps => {
  const headerObjects =
    options?.showHeader === false
      ? []
      : buildSlideMasterHeader(options?.brandLogoWithMetadata ?? null);

  return {
    title: options?.masterName ?? DEFAULT_SLIDE_MASTER,
    background: { path: options?.backgroundPath ?? slideBackground },
    objects: [
      ...headerObjects,
      ...buildSlideMasterFooter({
        text: FOOTER_TEXT,
      }),
    ],
  };
};
